import { Loader2, AlertCircle, Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn("h-5 w-5 animate-spin", className)} />;
}

export function CenteredLoader({ label }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 py-12 text-muted-foreground">
      <Spinner />
      <span className="text-sm">{label ?? "Caricamento…"}</span>
    </div>
  );
}

export function EmptyState({ title, description, icon }: { title: string; description?: string; icon?: React.ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12 text-center text-muted-foreground">
      <div className="rounded-full bg-muted p-4">{icon ?? <Inbox className="h-8 w-8" />}</div>
      <h4 className="text-base font-medium text-foreground">{title}</h4>
      {description && <p className="text-sm">{description}</p>}
    </div>
  );
}

export function ErrorState({ title, error }: { title?: string; error: unknown }) {
  const msg = error instanceof Error ? error.message : String(error);
  return (
    <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
      <div className="flex items-center gap-2 font-medium">
        <AlertCircle className="h-4 w-4" /> {title ?? "Errore"}
      </div>
      <p className="mt-1 break-all">{msg}</p>
    </div>
  );
}
